import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Stats from "./components/Stats/Stats";
import Services from "./components/Services/Services";
import Process from "./components/Process/Process";
import Testimonials from "./components/Testimonials/Testimonials";
import FAQ from "./components/FAQ/FAQ";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import ScrollTop from "./components/ScrollTop/ScrollTop";
import About from "./components/About/About";
import Preloader from "./components/Preloader/Preloader";
import Customers from "./components/Customers/Customers";

export default function App() {
  return (
    <>
      {/* ✅ Professional preloader */}
      <Preloader brand="NesflixDigital" tagline="Preparing your growth engine…" minDuration={900} />

      <Navbar />

      <main>
        <Hero />
        <About />
        <Services />
        <Process />
        <Customers />
        <Testimonials />
      <Contact />
      <FAQ />
      </main>

      <Footer />
      <ScrollTop />
    </>
  );
}
